import DatePicker from "react-datepicker"
import Label from "./Label"

import "react-datepicker/dist/react-datepicker.css"

export default function DateInput({ label, value, minDate, showTimeSelect, size, placeholder, onChange, format = 'dd/MM/yyyy' }) {

   let sizeClass
   switch (size) {
      default:
         break
      case "lg":
         sizeClass = "py-3"
         break
   }

   const finalClass = `${sizeClass} bg-white focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md`
   
   return (
      <div className="relative">
         {label && <Label>{label}</Label>}
         <DatePicker
            className={finalClass}
            selected={value}
            onChange={onChange}
            dateFormat={format}
            minDate={minDate}
            showTimeSelect={showTimeSelect}
            placeholderText={placeholder}
         />
      </div>
   )
}